interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
}

export default function EmptyState({
  icon = "ri-inbox-line",
  title,
  description,
  actionLabel,
  onAction,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-50 px-6 py-16 text-center">
      <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-secondary-100">
        <i className={`${icon} text-3xl text-secondary-600`} />
      </div>
      <p className="text-base font-semibold text-foreground-900">{title}</p>
      {description ? (
        <p className="mt-2 max-w-md text-sm text-foreground-500">{description}</p>
      ) : null}
      {actionLabel && onAction ? (
        <button
          type="button"
          onClick={onAction}
          className="mt-5 cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-5 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
        >
          {actionLabel}
        </button>
      ) : null}
    </div>
  );
}